<template>
	<div>


		<h3>Sales Calculator</h3>
		<section>
			<div>
		      <div class="row collapse">
		        <label class="strong" for="classPrice">Desired Class Price</label>
		        <div class="small-3 columns">
		          <span class="prefix">£</span>
		        </div>
		        <div class="small-9 columns">
		          <input type="number" id="classPrice" name="classPrice" v-model.number="classPrice">
		        </div>
		      </div>
			</div>

			<div>
		      <div class="row collapse">
		        <label class="strong" for="percent">Platform Fee Percentage</label>
		        <div class="small-9 columns">
		          <input type="number" id="percent" name="percent" v-model.number="percent">
		        </div>
		        <div class="small-3 columns">
		          <span class="postfix">%</span>
		        </div>
		      </div>
			</div>

			<div>
		      <div class="row collapse">
		        <label class="strong" for="fixed">Fixed Fee</label>
		        <div class="small-9 columns">
		          <input type="number" id="fixed" name="fixed" v-model.number="fixed">
		        </div>
		        <div class="small-3 columns">
		          <span class="postfix">p</span>
		        </div>
		      </div>				
			</div>

			<div>
				<label class="strong" for="bookingCount">Bookings</label>
				<input type="number" id="bookingCount" name="bookingCount" v-model.number="bookingCount">
			</div>

			<div>
				<label class="strong" for="passOnTotal">Cost if you pass on to parents</label>
				<h5>£{{passOnTotal}}</h5>
			</div>


			<div>
				<label class="strong" for="absorbTotal">How much to increase to get Desired Class Price</label>
				<h5>£{{absorbTotal}}</h5>

				<label class="strong" for="increase">Cost of processing for ClassForKids </label>
				<h5>£{{(absorbTotal - classPrice).toFixed(2)}}</h5>

			</div>


			<div>
				<label class="strong" for="absorbTotalRoundedUp">Rounded Up to nearest 100</label>
				<h5>£{{absorbTotalRounded}}</h5>
			</div>

			<div>
				<label class="strong" for="potentialIncrease">Profit if rounded up</label>
				<h5>£{{potentialIncrease}}</h5>

				<label class="strong" for="extra">Like having X extra bookings</label>
				<h5>{{parseInt(potentialIncrease / classPrice)}}</h5>

			</div>





			

		</section>
		
	</div>
</template>


<script>
'use strict';
	export default {
		name: 'SalesCalculator',
		data() {
			return {
				classPrice: 100,
				percent: 4.5,
				fixed: 20,
				bookingCount: 1
			}
		},

		methods: {
		
		},

		computed: {

			increase() {
				return (this.percent / 100) * this.classPrice;
			},

			increaseWithFixed() {
				return this.increase + (this.fixed / 100);
			},

			passOnTotal() {
				return (this.classPrice + this.increaseWithFixed).toFixed(2);
			},

			absorbTotal() {
				return ( (this.classPrice + (this.fixed / 100)) / (1 - this.percent / 100) ).toFixed(2);
			},

			absorbTotalRounded() {
				return Math.ceil(this.absorbTotal);
			},

			potentialIncrease() {
				return ((this.absorbTotalRounded - this.absorbTotal) * this.bookingCount).toFixed(2);
			}

		},

		components: {

		},

		beforeMount() {

		},

		mounted() {},
		created() {

		}

	}	
</script>



<style scoped>

section {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-gap: 16px;
}

	
</style>